import _ from 'underscore'

export default function findEnglishVideo(videos = []) {
  const englishVideos = videos.filter(video =>
    _.str.startsWith(video.languageCode, 'en')
  )

  return englishVideos[0]
}



// WEBPACK FOOTER //
// ../src/utils/findEnglishVideo.js